import React from "react";

import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Grid } from "../../UI/Grid";
import { Box } from "../../UI/Box";
import { Typography } from "../../UI/Typography";

interface IProps {
  group: string;
  handleDelete: VoidFunction;
}

export const GenderGroupDeleteModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const handleClose = () => setIsOpen(false);

  return (
    <Modal
      maxWidth="xs"
      title="Delete Gender Group"
      actions={
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button onClick={handleClose}>Cancel</Button>
          </Grid>
          <Grid item>
            <Button appearance="danger" onClick={props.handleDelete}>
              Delete Gender Group
            </Button>
          </Grid>
        </Grid>
      }
    >
      <Box px={3} py={2}>
        <Typography paragraph>
          You are about to delete a gender group. By doing this, all gender options associated with this group will also
          be deleted. Users that have selected an associated gender option will be prompted to select a new gender
          option.
        </Typography>
        <Typography paragraph>
          <strong>Gender Group to Delete:</strong> {props.group} (and all associated gender options)
        </Typography>
      </Box>
    </Modal>
  );
};
